import isEmpty from 'lodash/isEmpty';
import React, { FC, ReactNode, useMemo } from 'react';

import { OnlyOneLeft } from 'components/OnlyOneLeft/OnlyOneLeft';
import { Season } from 'components/Season/Season';
import { fontFamilies } from 'components/UI/Font';
import { useAppContext } from 'store/appContext';

/* eslint-disable react/no-danger */

export const DescriptionProductDetails: FC<{
  brandName: string;
  description: string;
  formattedModelNumber: string;
  formattedSeason: string;
  isLastOne: boolean;
  isSomeSizeLastOne: boolean;
  madeIn: string;
  model: string;
  styleList: ReactNode;
}> = ({
  brandName,
  description,
  formattedModelNumber,
  formattedSeason,
  isLastOne,
  isSomeSizeLastOne,
  madeIn,
  model,
  styleList,
}) => {
  const { madeInCountries } = useAppContext();

  const madeInCountry = useMemo(() => {
    return madeInCountries[madeIn];
  }, [madeInCountries, madeIn]);

  return (
    <div>
      <Season formattedSeason={formattedSeason} />

      <div className="brand-container">
        <div className="brand">{brandName}</div>
        {isLastOne && (
          <div className="only-one-left">
            <OnlyOneLeft justifyContent="flex-start" />
          </div>
        )}
      </div>

      <div className="model">{model}</div>

      {formattedModelNumber && <p className="model-number desktop">Model number: {formattedModelNumber}</p>}

      <div className="description-container" dangerouslySetInnerHTML={{ __html: description }} />
      {madeIn && !isEmpty(madeInCountry) && (
        <>
          {madeInCountry?.is_tax_ue_zone !== 'N' ? (
            <p className="model-number">Made in {madeInCountry?.country}</p>
          ) : (
            <p className="model-number">Imported</p>
          )}
        </>
      )}
      <div className="style-container">{styleList}</div>

      {isSomeSizeLastOne && (
        <p className="note">*Please note: the same item may be available on our site from another partner boutique.</p>
      )}

      <style jsx>{`
        .model {
          line-height: 1;
          margin-bottom: 30px;
        }

        .brand-container {
          display: flex;
          justify-content: start;
          width: 100%;
          align-items: center;
        }
        .brand {
          font-size: 24px;
          font-family: ${fontFamilies.bold};
          font-weight: normal;
          letter-spacing: 1px;
          line-height: 36px;
          text-transform: uppercase;
        }
        @media (min-width: 1024px) {
          .brand {
            font-size: 30px;
            line-height: 46px;
          }
        }
        .only-one-left {
          margin-left: 14px;
        }

        .model-number {
          margin-bottom: 30px;
        }

        .description-container {
          margin-bottom: 30px;
        }
        .description-container a {
          text-decoration: underline;
        }
        .description-container > ul {
          margin: 0;
        }

        .style-container {
          margin-bottom: 30px;
        }

        .note {
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
};
